import { render, staticRenderFns } from "./TheEdicAdminFacilityContent.vue?vue&type=template&id=c66c8bc2&"
import script from "./TheEdicAdminFacilityContent.vue?vue&type=script&lang=js&"
export * from "./TheEdicAdminFacilityContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports